export default "<app-game-carousel [images]=\"images\" ></app-game-carousel>\n<div class=\"body\" [innerHTML]=\"game?.content|safeHtml\"></div>\n"